export const useSessionTimer = () => {
    const remainMs = useState<number>('session.remainMs', () => 0)
    const is27Reached = useState<boolean>('session.is27Reached', () => false)
    const is3Reached = useState<boolean>('session.is3Reached', () => false)

    const remainText = computed(() => {
        const totalSec = Math.max(0, Math.floor(remainMs.value / 1000))
        const m = String(Math.floor(totalSec / 60)).padStart(2, '0')
        const s = String(totalSec % 60).padStart(2, '0')
        return `${m}:${s}`
    })

    return {remainMs, remainText, is27Reached, is3Reached }
}